import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class VirtualTagsService {
    static readonly WCD_TAG_ID: number = 28;
    static readonly ECO_HEROES_TAG_ID: number = 29;
    static readonly HELP_UKRAINE_TAG_ID: number = 30;
    static readonly BACKBASE_TAG_ID: number = 41;

    isVirtualTag(tagId: number): boolean {
        return [
            VirtualTagsService.WCD_TAG_ID,
            VirtualTagsService.ECO_HEROES_TAG_ID,
            VirtualTagsService.HELP_UKRAINE_TAG_ID,
            VirtualTagsService.BACKBASE_TAG_ID
        ].includes(tagId);
    }

    tagRouterLink(tagId: number, elementType: string): string {
        switch (tagId) {
            case VirtualTagsService.WCD_TAG_ID:
                return '/worldcleanupday';
            case VirtualTagsService.ECO_HEROES_TAG_ID:
                return '/ecoheroes';
            case VirtualTagsService.HELP_UKRAINE_TAG_ID:
                return '/helpukraine';
            case VirtualTagsService.BACKBASE_TAG_ID:
                return '/backbase';
            default:
                if (elementType == 'project') {
                    return '/projects/verified';
                } else {
                    return '/events'
                }
        }
    }

    tagQueryParams(tagId: number): object {
        if (this.isVirtualTag(tagId)) {
            if (tagId == VirtualTagsService.ECO_HEROES_TAG_ID) {
                return {
                    per_page: 32,
                    filters_status: 'ended'
                };
            } else {
                return {};
            }
        } else {
            return {
                filters_category: tagId
            }
        }
    }
}
